import { ikeaEnv } from 'lib/global';
import { defaults } from './defaults';
import { localhost } from './localhost';
import { prCte } from './pr-cte';
import { prPpe } from './pr-ppe';

const defaultsByEnv = {
    'pr-ppe': prPpe,
    'pr-cte': prCte,
    localhost,
} as const;

const usen =
    ikeaEnv in defaultsByEnv
        ? {
              ...defaults,
              ...defaultsByEnv[ikeaEnv as keyof typeof defaultsByEnv],
          }
        : defaults;

export default usen;
